export default {
  'fabric.preview': 'Aperçu PDF sans valeur fictive',
  'fabric.remove': "Supprimer l'objet",
  'fabric.text_options': 'Options de texte',
  'fabric.image_options': "Options d'image",
  'fabric.line_options': 'Options de ligne',
  'fabric.object_options': "Options d'objet",
  'fabric.stroke_color': 'Couleur du trait',
  'fabric.background_color': 'Couleur de fond',
  'fabric.stroke_width': 'Largeur du trait',
  'fabric.line_color': 'Couleur de la ligne',
  'fabric.font_family': 'Famille de police',
  'fabric.font_size': 'Taille de police',
  'fabric.text_align': 'Alignement du texte',
  'fabric.line_height': 'Hauteur de ligne',
  'fabric.bold': 'Gras',
  'fabric.italic': 'Italique',
  'fabric.underline': 'Souligné',
  'fabric.linethrough': 'Barré',
  'fabric.overline': 'Surmonté',
  'fabric.text_color': 'Couleur du texte',
  'fabric.text_background': 'Couleur de fond du texte',
  'fabric.add_circle': 'Ajouter un cercle',
  'fabric.add_rectangle': 'Ajouter un rectangle',
  'fabric.add_line': 'Ajouter une ligne',
  'fabric.add_image': 'Ajouter une image',
  'fabric.add_object': 'Ajouter un objet',
  'fabric.add_text': 'Ajouter du texte',
  'fabric.add_textbox': 'Ajouter une zone de texte',
  'fabric.clear': "Effacer l'éditeur",
  'fabric.editor_options': "Options de l'éditeur",
  'fabric.add': 'Ajouter ',
  'fabric.editor_background_color': "Couleur de fond de l'éditeur",
};
